/** 充值相关 */
export enum DepositReason {
  /** 充值 */
  DEPOSIT = 10,
  /** 其他货币-平台币 */
  //   SWAP_IN = 201,
  /** 平台币-其他货币 */
  //   SWAP_OUT = 202,
  /** 站内转账 */
  TRANSFER = 210,
}

/** 提现相关 */
export enum WithdrawReason {
  /** 提现冻结 */
  FREEZE = 101,
  /** 提现解冻 */
  RELEASE = 102,
  /** 提现核销 */
  WRITE_OFF = 103,
}

/** C2C订单相关 */
export enum C2COrderReason {
  /** C2C挂单冻结 */
  FREEZE = 201,
  /** C2C挂单解冻 */
  RELEASE = 202,
  /** C2C挂单核销 */
  WRITE_OFF = 203,
  /** C2C挂单核销给用户 */
  WRITE_OFF_TO_USER = 204,
}

/** C2C广告相关 */
export enum C2CAdsReason {
  /** C2C广告冻结 */
  FREEZE = 301,
  /** C2C广告解冻 */
  RELEASE = 302,
  /** C2C广告核销 */
  WRITE_OFF = 303,
}

/** 人工操作相关 */
export enum ManualReason {
  /** 人工加扣款 */
  MANUAL = 900,
  /** 人工冻结 */
  FREEZE = 901,
  /** 人工解冻 */
  RELEASE = 902,
  /** 人工核销 */
  WRITE_OFF = 903,
}

/** 商户相关 */
export enum MerchantReason {
  /** 商户玩家充值：用户钱包->商户钱包 */
  MEMBER_TOPUP = 1001,
  /** 商户玩家提款：商户钱包->用户钱包 */
  MEMBER_PAYOUT = 1002,
}

/** 码商申请相关 */
export enum AgentApplyReason {
  /** 用户-码商，冻结保证金 */
  FREEZE = 1011,
  /** 冻结后业务失败，自动解冻 */
  ERR_RELEASE = 1012,
  /** 用户-码商，审核拒绝，解冻保证金 */
  REJECT = 1013,
  /** 码商-用户，解冻保证金 */
  REFUND = 1014,
}

/** 集成所有账变原因的命名空间 */
export namespace FlowReason {
  export import Deposit = DepositReason
  export import Withdraw = WithdrawReason
  export import C2COrder = C2COrderReason
  export import C2CAds = C2CAdsReason
  export import Manual = ManualReason
  export import Merchant = MerchantReason
  export import AgentApply = AgentApplyReason
}

/** 所有账变原因值的联合类型 */
export type FlowReasonValue =
  | DepositReason
  | WithdrawReason
  | C2COrderReason
  | C2CAdsReason
  | ManualReason
  | MerchantReason
  | AgentApplyReason

/** 账变原因描述映射 */
export const FlowReasonMap: Record<number, string> = {
  /** 充值相关 */
  [DepositReason.DEPOSIT]: '充值',
  //   [DepositReason.SWAP_IN]: '币种兑换入',
  //   [DepositReason.SWAP_OUT]: '币种兑换出',
  [DepositReason.TRANSFER]: '站内转账',

  /** 提现相关 */
  [WithdrawReason.FREEZE]: '提现冻结',
  [WithdrawReason.RELEASE]: '提现解冻',
  [WithdrawReason.WRITE_OFF]: '提现核销',

  /** C2C订单相关 */
  [C2COrderReason.FREEZE]: '订单冻结',
  [C2COrderReason.RELEASE]: '订单解冻',
  [C2COrderReason.WRITE_OFF]: '订单核销',
  [C2COrderReason.WRITE_OFF_TO_USER]: '订单核销给用户',

  /** C2C广告相关 */
  [C2CAdsReason.FREEZE]: '挂单冻结',
  [C2CAdsReason.RELEASE]: '挂单解冻',
  [C2CAdsReason.WRITE_OFF]: '挂单核销',

  /** 人工操作相关 */
  [ManualReason.MANUAL]: '人工调整',
  [ManualReason.FREEZE]: '人工冻结',
  [ManualReason.RELEASE]: '人工解冻',
  [ManualReason.WRITE_OFF]: '人工核销',

  /** 商户相关 */
  [MerchantReason.MEMBER_TOPUP]: '商户充值',
  [MerchantReason.MEMBER_PAYOUT]: '商户提款',

  /** 码商申请相关 */
  [AgentApplyReason.FREEZE]: '保证金冻结',
  [AgentApplyReason.ERR_RELEASE]: '保证金解冻',
  [AgentApplyReason.REJECT]: '申请拒绝退款',
  [AgentApplyReason.REFUND]: '保证金退回',
}

/** 获取账变原因描述 */
export function getFlowReasonText(reason: number): string {
  return FlowReasonMap[reason] || '未知类型'
}

/** 判断是否为收入 */
export function isIncome(reason: number): boolean {
  return [
    DepositReason.DEPOSIT,
    // DepositReason.SWAP_IN,
    DepositReason.TRANSFER,
    WithdrawReason.RELEASE,
    C2COrderReason.RELEASE,
    C2COrderReason.WRITE_OFF_TO_USER,
    C2CAdsReason.RELEASE,
    ManualReason.RELEASE,
    MerchantReason.MEMBER_PAYOUT,
    AgentApplyReason.ERR_RELEASE,
    AgentApplyReason.REJECT,
    AgentApplyReason.REFUND,
  ].includes(reason)
}
